// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The old .main-content / .main-content-body rules used to live here.
   The scroll container is now just .app-layout-main (see AppLayout.css) —
   the page scrolls normally and the header/sidebar stay pinned via
   position: sticky, so there's nothing app-layout-specific left to put
   here. */

/* SIDEBAR BASE */
.custom-sidebar {
  width: var(--sidebar-width);
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: var(--header-height);
  height: calc(100vh - var(--header-height));
  transition: width 0.25s ease;
  z-index: 1030;
  background: var(--card-bg) !important;
  border-right: 1px solid var(--border);
  box-shadow: 2px 0 12px var(--shadow);
}

/* Just in case CoreUI's own mobile backdrop ever renders, don't let it
   block taps — we manage our own overlay/backdrop below. */
.sidebar-backdrop {
  display: none !important;
}

/* =========================================================
   LARGE SCREENS (> 992px): permanent icon rail, hover to expand.
   ========================================================= */
@media (min-width: 993px) {
  .custom-sidebar.custom-sidebar.custom-sidebar {
    margin-inline-start: 0 !important;
    transform: none !important;
  }

  /* expanded overlays content — fixed, so it floats above the page
     instead of pushing content over. Starts below the header rather
     than at the very top of the viewport. */
  .custom-sidebar:hover {
    width: var(--sidebar-width-expanded) !important;
    position: fixed !important;
    top: var(--header-height);
    left: 0;
    height: calc(100vh - var(--header-height));
    z-index: 1150;
    box-shadow: 4px 0 24px var(--shadow-lg);
  }

  .custom-sidebar:hover .nav-link-text {
    overflow: visible;
    text-overflow: unset;
  }

  .sidebar-narrow:hover .nav-link {
    justify-content: flex-start;
  }

  .sidebar-narrow:hover .nav-link-text {
    opacity: 1;
    max-width: 200px;
    margin-left: 10px;
  }
}

/* Small breathing room at the top now that there's no brand block —
   the header above already carries the logo. */
.custom-sidebar .sidebar-nav {
  padding-top: 10px;
}

/* COLLAPSED STATE */
.sidebar-narrow .nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* ICON ALWAYS VISIBLE */
.sidebar-narrow .nav-icon {
  width: 24px;
  flex: 0 0 24px;
  text-align: center;
}

/* TEXT HIDDEN ONLY IN COLLAPSED */
.sidebar-narrow .nav-link-text {
  opacity: 0;
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  transition: opacity 0.15s ease;
}

/* allow text to stay single line */
.nav-link-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Rounded, right-edge nav "pills" — matches the softer, card-style
   language used across the rest of the app now. */
.custom-sidebar .nav-link {
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  margin-right: 10px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.active-country:hover {
  background: transparent !important;
}

/* normal active */
.nav-link.active-country {
  pointer-events: none;
  cursor: default;

  background: var(--selected-country-menu) !important;
  border-left: 3px solid var(--primary);
  opacity: 0.85;

  color: var(--text-primary) !important;
  font-weight: 600;
}

.selected-country {
  background: var(--country-selected-bg) !important;
  border-left: 3px solid var(--country-selected-border);
}

.selected-country:hover {
  background: var(--country-selected-bg-hover) !important;
}

/* selected in compare mode */
.nav-link.selected-country {
  background: var(--country-selected-bg) !important;
  border-left: 3px solid var(--country-selected-border);
}

/* active + compare mode (special highlight) */
.nav-link.active-country-compare {
  background: var(--country-compare-bg) !important;
  border-left: 3px solid var(--country-compare-border);
  font-weight: 600;
}

.nav-toggler-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-switch-end {
  margin-left: auto;
}

/* =========================================================
   MEDIUM & SMALL SCREENS (<= 992px): button-driven drawer.
   ========================================================= */
.sidebar-mobile-handle,
.sidebar-mobile-close,
.sidebar-mobile-backdrop {
  display: none;
}

@media (max-width: 992px) {
  .custom-sidebar,
  .custom-sidebar:hover {
    position: fixed !important;
    top: var(--header-height);
    left: 0;
    height: calc(100vh - var(--header-height));
    width: min(85vw, 300px) !important;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    box-shadow: 4px 0 24px var(--shadow-lg);
    z-index: 1150;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  /* Always show full labels inside the drawer */
  .custom-sidebar .nav-link-text {
    opacity: 1 !important;
    max-width: 200px !important;
    margin-left: 10px !important;
    overflow: visible;
    text-overflow: unset;
  }

  /* Let the outer drawer above own the scrolling */
  .custom-sidebar .sidebar-nav {
    overflow: visible;
    height: auto;
    max-height: none;
    flex: 1 1 auto;
  }

  /* The actual open state. */
  .custom-sidebar.mobile-open,
  .custom-sidebar.mobile-open:hover {
    transform: translateX(0) !important;
  }

  /* Handle that opens the drawer */
  .sidebar-mobile-handle {
    display: flex;
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 28px;
    height: 56px;
    align-items: center;
    justify-content: center;
    background: var(--card-bg);
    color: var(--primary);
    border: 1px solid var(--border);
    border-left: none;
    border-radius: 0 var(--radius-md) var(--radius-md) 0;
    box-shadow: 2px 0 12px var(--shadow);
    z-index: 1120;
    cursor: pointer;
  }

  /* Close button inside the open drawer */
  .sidebar-mobile-close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 14px;
    right: 14px;
    width: 30px;
    height: 30px;
    border-radius: var(--radius-sm);
    border: none;
    background: transparent;
    color: var(--text-secondary);
    cursor: pointer;
    z-index: 1;
  }
  .sidebar-mobile-close:hover {
    background: var(--hover);
  }

  /* Stops short of the header so it stays visible/usable while the
     drawer is open. */
  .sidebar-mobile-backdrop {
    display: block;
    position: fixed;
    top: var(--header-height);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1140;
  }
}

@media (min-width: 993px) {
  .custom-sidebar:not(:hover) .nav-link.active-country,
  .custom-sidebar:not(:hover) .nav-link.selected-country,
  .custom-sidebar:not(:hover) .nav-link.active-country-compare {
    margin-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SideMenu.css"],"names":[],"mappings":"AAAA;;;;UAIU;;AAEV,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,4BAA4B;EAC5B,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;2DAC2D;AAC3D;EACE,wBAAwB;AAC1B;;AAEA;;8DAE8D;AAC9D;EACE;IACE,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;;4CAE0C;EAC1C;IACE,+CAA+C;IAC/C,0BAA0B;IAC1B,yBAAyB;IACzB,OAAO;IACP,0CAA0C;IAC1C,aAAa;IACb,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;+CAC+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;kDACkD;AAClD;EACE,oDAAoD;EACpD,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,eAAe;;EAEf,mDAAmD;EACnD,qCAAqC;EACrC,aAAa;;EAEb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;AACzD;;AAEA,6BAA6B;AAC7B;EACE,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA,8CAA8C;AAC9C;EACE,gDAAgD;EAChD,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;8DAE8D;AAC9D;;;EAGE,aAAa;AACf;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,yBAAyB;IACzB,OAAO;IACP,0CAA0C;IAC1C,kCAAkC;IAClC,4BAA4B;IAC5B,gCAAgC;IAChC,uCAAuC;IACvC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,iDAAiD;EACjD;IACE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;;IAEE,mCAAmC;EACrC;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,oDAAoD;IACpD,oCAAoC;IACpC,aAAa;IACb,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;;EAEA;sBACoB;EACpB;IACE,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":["/* The old .main-content / .main-content-body rules used to live here.\n   The scroll container is now just .app-layout-main (see AppLayout.css) —\n   the page scrolls normally and the header/sidebar stay pinned via\n   position: sticky, so there's nothing app-layout-specific left to put\n   here. */\n\n/* SIDEBAR BASE */\n.custom-sidebar {\n  width: var(--sidebar-width);\n  flex-shrink: 0;\n  align-self: flex-start;\n  position: sticky;\n  top: var(--header-height);\n  height: calc(100vh - var(--header-height));\n  transition: width 0.25s ease;\n  z-index: 1030;\n  background: var(--card-bg) !important;\n  border-right: 1px solid var(--border);\n  box-shadow: 2px 0 12px var(--shadow);\n}\n\n/* Just in case CoreUI's own mobile backdrop ever renders, don't let it\n   block taps — we manage our own overlay/backdrop below. */\n.sidebar-backdrop {\n  display: none !important;\n}\n\n/* =========================================================\n   LARGE SCREENS (> 992px): permanent icon rail, hover to expand.\n   ========================================================= */\n@media (min-width: 993px) {\n  .custom-sidebar.custom-sidebar.custom-sidebar {\n    margin-inline-start: 0 !important;\n    transform: none !important;\n  }\n\n  /* expanded overlays content — fixed, so it floats above the page\n     instead of pushing content over. Starts below the header rather\n     than at the very top of the viewport. */\n  .custom-sidebar:hover {\n    width: var(--sidebar-width-expanded) !important;\n    position: fixed !important;\n    top: var(--header-height);\n    left: 0;\n    height: calc(100vh - var(--header-height));\n    z-index: 1150;\n    box-shadow: 4px 0 24px var(--shadow-lg);\n  }\n\n  .custom-sidebar:hover .nav-link-text {\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .sidebar-narrow:hover .nav-link {\n    justify-content: flex-start;\n  }\n\n  .sidebar-narrow:hover .nav-link-text {\n    opacity: 1;\n    max-width: 200px;\n    margin-left: 10px;\n  }\n}\n\n/* Small breathing room at the top now that there's no brand block —\n   the header above already carries the logo. */\n.custom-sidebar .sidebar-nav {\n  padding-top: 10px;\n}\n\n/* COLLAPSED STATE */\n.sidebar-narrow .nav-link {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* ICON ALWAYS VISIBLE */\n.sidebar-narrow .nav-icon {\n  width: 24px;\n  flex: 0 0 24px;\n  text-align: center;\n}\n\n/* TEXT HIDDEN ONLY IN COLLAPSED */\n.sidebar-narrow .nav-link-text {\n  opacity: 0;\n  max-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: opacity 0.15s ease;\n}\n\n/* allow text to stay single line */\n.nav-link-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Rounded, right-edge nav \"pills\" — matches the softer, card-style\n   language used across the rest of the app now. */\n.custom-sidebar .nav-link {\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  margin-right: 10px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.active-country:hover {\n  background: transparent !important;\n}\n\n/* normal active */\n.nav-link.active-country {\n  pointer-events: none;\n  cursor: default;\n\n  background: var(--selected-country-menu) !important;\n  border-left: 3px solid var(--primary);\n  opacity: 0.85;\n\n  color: var(--text-primary) !important;\n  font-weight: 600;\n}\n\n.selected-country {\n  background: var(--country-selected-bg) !important;\n  border-left: 3px solid var(--country-selected-border);\n}\n\n.selected-country:hover {\n  background: var(--country-selected-bg-hover) !important;\n}\n\n/* selected in compare mode */\n.nav-link.selected-country {\n  background: var(--country-selected-bg) !important;\n  border-left: 3px solid var(--country-selected-border);\n}\n\n/* active + compare mode (special highlight) */\n.nav-link.active-country-compare {\n  background: var(--country-compare-bg) !important;\n  border-left: 3px solid var(--country-compare-border);\n  font-weight: 600;\n}\n\n.nav-toggler-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.nav-switch-end {\n  margin-left: auto;\n}\n\n/* =========================================================\n   MEDIUM & SMALL SCREENS (<= 992px): button-driven drawer.\n   ========================================================= */\n.sidebar-mobile-handle,\n.sidebar-mobile-close,\n.sidebar-mobile-backdrop {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .custom-sidebar,\n  .custom-sidebar:hover {\n    position: fixed !important;\n    top: var(--header-height);\n    left: 0;\n    height: calc(100vh - var(--header-height));\n    width: min(85vw, 300px) !important;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease;\n    box-shadow: 4px 0 24px var(--shadow-lg);\n    z-index: 1150;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n  }\n\n  /* Always show full labels inside the drawer */\n  .custom-sidebar .nav-link-text {\n    opacity: 1 !important;\n    max-width: 200px !important;\n    margin-left: 10px !important;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  /* Let the outer drawer above own the scrolling */\n  .custom-sidebar .sidebar-nav {\n    overflow: visible;\n    height: auto;\n    max-height: none;\n    flex: 1 1 auto;\n  }\n\n  /* The actual open state. */\n  .custom-sidebar.mobile-open,\n  .custom-sidebar.mobile-open:hover {\n    transform: translateX(0) !important;\n  }\n\n  /* Handle that opens the drawer */\n  .sidebar-mobile-handle {\n    display: flex;\n    position: fixed;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    width: 28px;\n    height: 56px;\n    align-items: center;\n    justify-content: center;\n    background: var(--card-bg);\n    color: var(--primary);\n    border: 1px solid var(--border);\n    border-left: none;\n    border-radius: 0 var(--radius-md) var(--radius-md) 0;\n    box-shadow: 2px 0 12px var(--shadow);\n    z-index: 1120;\n    cursor: pointer;\n  }\n\n  /* Close button inside the open drawer */\n  .sidebar-mobile-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 14px;\n    right: 14px;\n    width: 30px;\n    height: 30px;\n    border-radius: var(--radius-sm);\n    border: none;\n    background: transparent;\n    color: var(--text-secondary);\n    cursor: pointer;\n    z-index: 1;\n  }\n  .sidebar-mobile-close:hover {\n    background: var(--hover);\n  }\n\n  /* Stops short of the header so it stays visible/usable while the\n     drawer is open. */\n  .sidebar-mobile-backdrop {\n    display: block;\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.35);\n    z-index: 1140;\n  }\n}\n\n@media (min-width: 993px) {\n  .custom-sidebar:not(:hover) .nav-link.active-country,\n  .custom-sidebar:not(:hover) .nav-link.selected-country,\n  .custom-sidebar:not(:hover) .nav-link.active-country-compare {\n    margin-right: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
